const baseRoutes = [
  {
    path: 'menu/cameras',
    component: () => import("@/_routes/tabs/menu/cameras/Root"),
  },
  {
    path: 'menu/cameras/:deviceId',
    component: () => import("@/_routes/camera/Root")
  },
  {
    path: 'menu/cameras/:deviceId/notification',
    component: () => import("@/_routes/camera/Notification")
  }
]

const routes = baseRoutes

export default routes
